import baseScmService from 'services/baseScmService';

const courseAssessmentMenteeService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    createResetSat: build.mutation({
      query: ({ email }) => ({
        url: '/course-assessment-mentees/reset-sat',
        method: 'POST',
        body: {
          email,
        },
      }),
    }),
    getCourseAssesmentBatchTimings: build.query({
      query: ({ superBatchId }) => ({
        method: 'GET',
        url: `/course-assessment-batch-timings/`,
        params: {
          super_batch_group_id: superBatchId,
        },
      }),
    }),
    updateAssesmentBatchAssociation: build.mutation({
      query: ({ data }) => ({
        method: 'POST',
        url: `/course-assessment-batch-associations/`,
        body: data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateResetSatMutation,
  useLazyGetCourseAssesmentBatchTimingsQuery,
  useUpdateAssesmentBatchAssociationMutation,
} = courseAssessmentMenteeService;

export default courseAssessmentMenteeService;
